import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="flex min-h-[60vh] flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
        <p className="font-heading text-6xl font-black text-primary-200">404</p>
        <h1 className="mt-3 font-heading text-2xl font-black text-foreground-950">页面不存在</h1>
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的页面可能已移动或链接有误。可以返回首页，或从女优分类、影视作品与新闻动态继续浏览。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-5-line" aria-hidden="true"></i>
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-1.5 rounded-md border border-background-300 px-4 py-2 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            浏览女优分类
          </Link>
          <Link
            to="/work-list"
            className="inline-flex items-center gap-1.5 rounded-md border border-background-300 px-4 py-2 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            影视作品列表
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}